// src/features/inventory/services/scanners.js
import { apiClient } from '../../../services/api/client';

export const scannersAPI = {
  getScanners: () => apiClient.get('/api/v1/inventory/scanners'),

  createScanner: (data) => apiClient.post('/api/v1/inventory/scanners', data),

  updateScanner: (scannerId, data) => apiClient.put(`/api/v1/inventory/scanners/${scannerId}`, data),

  deleteScanner: (scannerId) => apiClient.delete(`/api/v1/inventory/scanners/${scannerId}`),
};
